import { render, staticRenderFns } from "./SplitterRegistration.vue?vue&type=template&id=19e71e70"
import script from "./SplitterRegistration.vue?vue&type=script&lang=js"
export * from "./SplitterRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports